import * as React from 'react';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface ICardUploadIconProps {
  stroke?: string;
}

export const CardUploadIcon: React.FunctionComponent<ICardUploadIconProps> = ({ stroke = '#8E69CE', ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="41" height="41" fill="none" viewBox="0 0 41 41" {...rest}>
    <path
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M12.166 27.167A6.667 6.667 0 0110.7 13.995 8.336 8.336 0 0127 10.5h.166A8.333 8.333 0 0128.833 27M25.5 22.167l-5-5m0 0l-5 5m5-5v20"
    />
  </svg>
);

export default CardUploadIcon;
